<div class="wrapper">
  <div class="wrapped-div">
    <div class="tab-header">
      <h2 routerLink='/user/login' routerLinkActive='active'>Sign In</h2>
      <h2 routerLink='/user/registration' routerLinkActive='active'>Sign Up</h2>
    </div>
    <div class="row">
      <div class="col-md-10 offset-md-1">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>